export const CLOCK_ID = '0x0000000000000000000000000000000000000000000000000000000000000006';
